import theme from "@/theme";

export const styles = {
  select: {
    backgroundColor: "#F7F9FB",
    borderRadius: "12px",
    fontSize: "14px",
    border: "1px solid #F4F5F6",
    ".MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "& .MuiSelect-select": {
      fontFamily: "Inter",
      fontWeight: 500,
      fontStyle: "normal",
      fontSize: "14px",
      lineHeight: "24px",
      letterSpacing: 0,
    },
  },
  menuItems: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontStyle: "normal",
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: 0,
    verticalAlign: "middle",
    whiteSpace: "normal",
    wordBreak: "break-word",
  },
  menuItemBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  menuItem: {
    borderRadius: "8px",
    padding: "8px",
    margin: "0 9px 0 8px",
    "&.Mui-selected": {
      backgroundColor: "#F4F5F6 !important",
    },
    "&:hover": {
      backgroundColor: "#F4F5F6",
    },
  },
  menuProps: {
    PaperProps: {
      className: "custom-scrollbar",
      sx: {
        backgroundColor: "#FFF",
        borderRadius: "8px",
        mt: "6px",
        maxHeight: "60vh",
        overflow: "auto",
      },
    },
  },
  checkbox: {
    width: "18px",
    height: "18px",
    padding: 0,
    borderRadius: "5px",
    color: "#7D8690",
    "&.Mui-checked": {
      color: theme.palette.custom.mainBlue,
    },
    "& .MuiSvgIcon-root": {
      borderRadius: "5px",
    },
  },

  tooltipWrapper: {
    width: 169,
    height: 26,
    background: "#000000CC",
    borderRadius: "4px",
    px: "8px",
    py: "4px",
  },

  tooltipText: {
    fontFamily: "Inter",
    fontSize: 12,
    lineHeight: "18px",
    color: "#FFFFFF",
    fontWeight: 400,
    whiteSpace: "nowrap",
  },
  tooltipProps: {
    backgroundColor: "transparent",
    boxShadow: "none",
    padding: 0,
  },
};
